import React from 'react';
import { UserRowContainer, UserName } from './style';
import { ProfileAvatar } from '../../ProfileAvatar/ProfileAvatar';
import { Text } from '../../../UI/Text';

import { config } from '../../../../Configurations';
import { HoverableLink } from '../../../Layouts';
import { generateSlugLink } from '../../../../Utils';

export const PlainUserRow = ({ smallImage, fullName, id }) => {
    const userLink = generateSlugLink({ name: fullName, id });

    return (
        <UserRowContainer>
            <HoverableLink to={`/${userLink}`}>
                <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${smallImage}`} />
            </HoverableLink>

            <HoverableLink to={`/${userLink}`}>
                <UserName>
                    <Text>{fullName}</Text>
                </UserName>
            </HoverableLink>
        </UserRowContainer>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/PlainUserRow/index.js